// import registerNpsElement from '@/modules/nps/register-nps-element';
import '@/shared/legacy/lib/feature-toggle/feature-toggle';
import { RegisterGlobalComponents } from './register-global-components';

/* Отключение NPS, описание в задаче https://huntflow.atlassian.net/browse/DEV-19067 */
// registerNpsElement();
RegisterGlobalComponents.register();
